export default "__VITE_ASSET__CMqCb6vY__"